import { render } from "./MultipleChoiceVertical.vue?vue&type=template&id=55376090"
import script from "./MultipleChoiceVertical.vue?vue&type=script&lang=js"
export * from "./MultipleChoiceVertical.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__